import CompareSardines from '../components/CompareSardines';
import PageLayout from '../components/pageLayout';

function CompareSardinesPage() {
    return (
        <PageLayout children={<CompareSardines/>} />
    );
}

export default CompareSardinesPage;
